import RadioDotsCharacter from "./RadioDotsCharacter";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default RadioDotsCharacter;
